export default __webpack_public_path__ + "static/media/cocuk-icon.b727080d.svg";